export default "__VITE_ASSET__pJwz4PTf__"